export const TYPE_BUTTONS = 'ChatButtonsMessage';
export const TYPE_BUTTON_CLICK = 'ChasitorButtonClick';
export const TYPE_CONTROL = 'ChatControl';
export const TYPE_CONNECTING_STATUS = 'ChatConnectingStatus';
export const TYPE_MENU = 'ChatMenuMessage';
export const TYPE_NO_BUTTON_CLICK = 'ChasitorNoButtonCLick';
export const TYPE_TRANSFER_DATA = 'ChasitorContactData';
export const TYPE_TRANSFER_FORM = 'ChatContactForm';
